import { render, staticRenderFns } from "./ExtraDaysConfigurationPopup.vue?vue&type=template&id=2319f500&"
import script from "./ExtraDaysConfigurationPopup.vue?vue&type=script&lang=js&"
export * from "./ExtraDaysConfigurationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports